import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/warn.svg'
import _imports_1 from '../assets/icons/check_mark.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-125c9014"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payments-completed-container" }
const _hoisted_2 = {
  key: 0,
  class: "loading-animation-container"
}
const _hoisted_3 = { class: "animation-container" }
const _hoisted_4 = { class: "loading-animation" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "warn-mark"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: "check-mark"
}
const _hoisted_8 = {
  key: 2,
  style: {"margin-top":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DotLottieVue = _resolveComponent("DotLottieVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_DotLottieVue, {
                style: {"height":"200px","width":"200px"},
                autoplay: "",
                loop: "",
                src: "/assets/loader.lottie"
              }),
              _createElementVNode("h4", null, _toDisplayString(_ctx.t("verifying-payment")), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.hasError)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : (_openBlock(), _createElementBlock("img", _hoisted_7)),
          _createElementVNode("h3", null, _toDisplayString(_ctx.getStatusTitle()), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.getStatusMessage()), 1),
          (_ctx.hasError && _ctx.paymentId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", null, "ID: " + _toDisplayString(_ctx.paymentId), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}